import { Injectable } from '@angular/core';
import { ConfigInterface } from '@core/interfaces';
import { Autos } from '@core/interfaces/catalogos.intefaces';
import { Request } from '@core/models/requests.model';

@Injectable({
  providedIn: 'root',
})
export class AutosService {
  private url = `ventas/catalogos/nuevos/auto/search`;

  constructor(private request: Request) {}

  getAllAutos(body?: any, brandId?: string) {
    const config: ConfigInterface = this.request.getConfigUser();
    const requestBody = body ? body : { idMarca: brandId ,configuracion: { basesDeDatos: config.basesDeDatos, idioma: config.idioma } };
    const options = { headers: this.request.headers };
    return this.request.Post<Autos>( this.url, requestBody, options);
  }

  formatValues(data: any[], keyProp: string, valueProp: string): { key: any; value: any }[] {
    return data.map(item => ({ key: item[keyProp], value: item[valueProp] }));
  }
}
